
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import LandingPage from './pages/LandingPage';
import ConsultationApp from './pages/ConsultationApp';
import Onboarding from './pages/Onboarding';
import FAQPage from './pages/FAQPage';
import { About, Privacy, Terms, Disclaimer, Contact, Accessibility } from './pages/StaticPages';
import { PartnersPage } from './pages/PartnersPage';
import WhoItsForPage from './pages/WhoItsForPage';
import FeedbackPage from './pages/FeedbackPage';
import { ConsultationPage, BotanicalRxPage, YogaAidPage, NutriHealPage } from './pages/PlatformPages';
import ManasAidPage from './pages/ManasAid';
import { PlanComparison } from './pages/PlanComparison';
import LearnAyurveda from './pages/LearnAyurveda';
import LearnNaturopathy from './pages/LearnNaturopathy';
import LearnAcupressure from './pages/LearnAcupressure';
import LearnTCM from './pages/LearnTCM';
import LearnHomeopathy from './pages/LearnHomeopathy';
import LearnComparison from './pages/LearnComparison';

const ScrollToTop = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (!hash) {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'instant'
            });
        }
    }, [pathname, hash]);

    return null;
};

const App: React.FC = () => {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Routes>
                {/* Marketing Site Routes */}
                <Route element={<Layout />}>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/who-its-for" element={<WhoItsForPage />} />
                    <Route path="/faq" element={<FAQPage />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/partners" element={<PartnersPage />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/disclaimer" element={<Disclaimer />} />
                    <Route path="/accessibility" element={<Accessibility />} />
                    <Route path="/feedback" element={<FeedbackPage />} />
                    <Route path="/consultation" element={<ConsultationPage />} />
                    <Route path="/botanical-rx" element={<BotanicalRxPage />} />
                    <Route path="/yoga-aid" element={<YogaAidPage />} />
                    <Route path="/nutri-heal" element={<NutriHealPage />} />
                    <Route path="/manas-aid" element={<ManasAidPage />} />
                    <Route path="/plan-comparison" element={<PlanComparison />} />

                    {/* Learn Pages */}
                    <Route path="/learn/what-is-ayurveda" element={<LearnAyurveda />} />
                    <Route path="/learn/what-is-naturopathy" element={<LearnNaturopathy />} />
                    <Route path="/learn/what-is-acupressure" element={<LearnAcupressure />} />
                    <Route path="/learn/what-is-traditional-chinese-medicine" element={<LearnTCM />} />
                    <Route path="/learn/what-is-homeopathy" element={<LearnHomeopathy />} />
                    <Route path="/learn/ancient-healing-traditions-compared" element={<LearnComparison />} />

                </Route>

                {/* App Routes */}
                <Route path="/app" element={<ConsultationApp />} />
                <Route path="/onboarding" element={<Onboarding />} />

                {/* Redirects */}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </BrowserRouter>
    );
};

export default App;
